import { useSyncExternalStore } from "react";
import { type TabsProps } from "antd";

// TRE-2076 — jeden próg „telefonu" dla całego panelu. Ten sam co `lg:` w Tailwindzie
// i stały sidebar w DashboardWrapper: poniżej hamburger zamiast sidebaru, taby na górze
// zamiast z lewej, drawery na cały ekran. Nie używamy `Grid.useBreakpoint()` z antd,
// bo przy pierwszym renderze zwraca pusty obiekt i desktop na ułamek sekundy dostaje
// układ mobilny; matchMedia odpowiada synchronicznie.
export const MOBILE_MAX_WIDTH = 1023;

const MOBILE_QUERY = `(max-width: ${MOBILE_MAX_WIDTH}px)`;

// TRE-2095 — osobny, niższy próg dla czatu: pływające okienka mieszczą się jeszcze na tablecie
// i w zwężonym oknie desktopu (trenerki pracują z dwoma oknami obok siebie, ~1000 px), więc
// pełnoekranowy /chat zamiast okienek dostaje dopiero telefon. Ten sam próg co `md:` w Tailwindzie.
export const PHONE_MAX_WIDTH = 767;

const PHONE_QUERY = `(max-width: ${PHONE_MAX_WIDTH}px)`;

const canMatchMedia = () => typeof window !== "undefined" && typeof window.matchMedia === "function";

const subscribeTo = (query: string) => (onChange: () => void) => {
  if (!canMatchMedia()) {
    return () => undefined;
  }
  const mediaQuery = window.matchMedia(query);
  mediaQuery.addEventListener("change", onChange);
  return () => mediaQuery.removeEventListener("change", onChange);
};

const snapshotOf = (query: string) => () => (canMatchMedia() ? window.matchMedia(query).matches : false);

const getServerSnapshot = () => false;

const subscribeMobile = subscribeTo(MOBILE_QUERY);
const getMobileSnapshot = snapshotOf(MOBILE_QUERY);
const subscribePhone = subscribeTo(PHONE_QUERY);
const getPhoneSnapshot = snapshotOf(PHONE_QUERY);

export const useIsMobile = (): boolean => useSyncExternalStore(subscribeMobile, getMobileSnapshot, getServerSnapshot);

export const useIsPhone = (): boolean => useSyncExternalStore(subscribePhone, getPhoneSnapshot, getServerSnapshot);

// Boczne taby (`tabPosition="left"`) na telefonie zjadają 1/3 szerokości — przenosimy je na górę.
// Próg telefonu, nie `useIsMobile()`: trenerki pracują na podzielonym ekranie (okno 800–1000 px)
// i taby przeskakujące na górę psuły im znany układ profilu klientki.
export const useSideTabsPosition = (): NonNullable<TabsProps["tabPosition"]> => (useIsPhone() ? "top" : "left");
